
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Properties from "../pages/properties/page";
import Contact from "../pages/contact/page";
import PropertyDetails from "../pages/property-details/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/properties",
    element: <Properties />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/property/:category/:id",
    element: <PropertyDetails />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
